import { render, staticRenderFns } from "./ui-ellipsis.vue?vue&type=template&id=e7f93bf8&scoped=true"
import script from "./ui-ellipsis.vue?vue&type=script&lang=js"
export * from "./ui-ellipsis.vue?vue&type=script&lang=js"
import style0 from "./ui-ellipsis.vue?vue&type=style&index=0&id=e7f93bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f93bf8",
  null
  
)

export default component.exports